import React from 'react'
import { connect } from 'react-redux'
import { getRankingService } from 'services/ranking'
import Navigation from 'support/navigation'
import View from './View'
import {
  showPopupDialog,
} from 'support/popup_dialogs'
import EditMyProfileDialog from 'pagesNewUi/profile/components/user_detail_section/components/edit_my_profile_dialog'
import { getBenchUserDisplayProfile, getBenchDropdowndatalist, getSearchApiBenchDatalist, getAllBenchUserDataList } from 'services/innovate/bench'
import { getInnovateUserIdeas,getInnovateMyIdea, postAddInnovateIdeaTeamMembar, postInviteInnovateIdeaTeamMembar } from 'services/innovate/idea'



const mapStateToProps = state => {
  return {
    myEmail: state.data.user.userEmail,
    benchUserDisplayProfileResponse: state.data.bench.benchUserDisplayProfile,
    isAdmin: state.data.user.admin,
    benchUserDisplayProfileLoading: state.data.bench.benchUserDisplayProfileLoading,
    myIdeasList: state.data.InnovateIdea.innovateMyIdeaList,
    myIdeasLoading: state.data.InnovateIdea.innovateMyIdeaIsLoading,
    addTeamMemberLoading: state.data.InnovateIdea.postInnovateIdeaAddTeamMemberIsLoading,
    inviteTeamMemberLoading: state.data.InnovateIdea.postInnovateIdeaInviteTeamMemberIsLoading,
    InnovateUserIdeasList:state.data.InnovateIdea.InnovateUserIdeasList ,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onEditMyProfile: () => showPopupDialog(<EditMyProfileDialog />, dispatch),
    getInnovateUserIdeas: email => dispatch(getInnovateUserIdeas(email)),
    getBenchUserDisplayProfileFn: (email) => dispatch(getBenchUserDisplayProfile(email)),
    getMyIdeasFn: () => dispatch(getInnovateMyIdea()),
    addTeamMemberFn: (params, onSuccess, onFailure) => {
      dispatch(postAddInnovateIdeaTeamMembar(params, onSuccess, onFailure))
    },
    inviteTeamMemberFn: (params, onSuccess, onFailure) => {
      dispatch(postInviteInnovateIdeaTeamMembar(params, onSuccess, onFailure))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)
